import * as h from './h';

let url = "/api/stats";

export let requestStatsByid = (upgradeIds, resultType) => h.post(url, {upgradeIds, resultType});
